import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import BasicTabs from "./components/tabs";
import styles from "./style.module.css";
import { useTheme } from "../../../context/themeContext";
import useManageProjects from "../../../hooks/useManageProjects";
import { useSelector } from "react-redux";
import LoadingButton from "../../../components/loading/button";

const Projects = () => {
  const { theme } = useTheme();
  const user = useSelector((state) => state.user.value);
  const { buttonLoading } = useSelector((state) => state.isLoading);
  const { fetchProjectsViewData } = useManageProjects();

  useEffect(() => {
    if (!user) return;
    fetchProjectsViewData();
  }, [user]);

  if (buttonLoading) {
    return (
      <Box className={styles.loading}>
        <LoadingButton />
      </Box>
    );
  }

  return (
    <Box className={styles.projects}>
      <Typography
        variant="body1"
        sx={{
          fontSize: "1.5rem",
          fontWeight: "500",
          textAlign: "centerd",
          display: "flex",
          alignSelf: "stretch",
          alignItems: "center",
          justifyContent: "center",
          color: theme.palette.darkgrey.darkgrey600,
        }}
      >
        Projects
      </Typography>
      <BasicTabs />
    </Box>
  );
};

export default Projects;
